import React, { forwardRef } from 'react'
import LogoJobmatrix from './LogoJobmatrix'

// Die Ueberschrift nimmt den Fokus nach einem Zustandswechsel an (#178):
// tabIndex -1 macht sie per Skript fokussierbar, ohne in die Tab-Reihenfolge
// zu geraten. h2, nicht h1: der MatchMeista steht immer unter einer Seite mit
// eigener h1 — als Abschnitt einer Messe oder als Shortcode einer WordPress-
// Seite (Audit 2026-10-07, S3).
const PageHeaderSkeleton = forwardRef(({
  title,
  subtitle,
  logo = <LogoJobmatrix />,
}, ref) => (

  <div className="jm-page-header">
      {logo}

      <h2 className="jm-title-matrix" tabIndex={-1} ref={ref}>+++ {title} +++</h2>
      <p className="jm-title-event">{subtitle}</p>
  </div>
));

export default PageHeaderSkeleton;
